var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "89.000000pt",
    height: "279.000000pt",
    viewBox: "0 0 89.000000 279.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,279.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330 2750 c-70 -15 -80 -34 -80 -154 0 -293 -8 -534 -19 -568 -6 -20 -36 -72 -66 -116 -30 -45 -65 -105 -77 -134 l-23 -53 0 -812 0 -813 25 -25 c40 -39 112 -47 399 -43 282 5 311 10 339 62 16 28 17 93 20 761 2 473 -1 758 -8 810 -11 87 -45 170 -102 250 -20 28 -42 64 -51 80 -26 52 -38 209 -34 446 2 123 1 235 -2 248 -13 49 -49 63 -167 67 -60 2 -129 -1 -154 -6z m246 -352 l0 -278 -125 0 -126 0 1 238 c0 130 1 256 2 280 l2 43 123 -3 122 -3 1 -277z m20 -375 c10 -39 40 -97 80 -152 61 -85 85 -151 91 -251 l6 -90 -323 0 -323 0 8 83 c9 108 31 167 99 266 31 46 62 103 68 127 l12 44 138 0 138 0 6 -27z m174 -1028 l0 -455 -320 0 -320 0 0 455 0 455 320 0 320 0 0 -455z m0 -687 c0 -90 -4 -169 -9 -177 -14 -22 -171 -34 -381 -28 -107 3 -203 8 -213 12 -10 4 -23 19 -28 32 -10 28 -13 306 -2 316 3 4 147 7 320 7 l313 0 0 -162z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottle);
export default __webpack_public_path__ + "static/media/bottle.1959b63420a11437777afccd5ddf6759.svg";
export { ForwardRef as ReactComponent };